module.exports = __webpack_public_path__ + "static/media/6.5435abb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/workoutPreview/img/6.png
// module id = 2113
// module chunks = 0